import produce from 'immer';
import {
	SEARCH_FAILED,
	SEARCH_FULFILLED,
	SEARH_PENDING,
	SET_SEARCHMODAL_STATE_FULFILLED,
} from '../constants/actions/searchActions';
import ITSearchReducer from '../interfaces/search/searchReducer';

const initialValues: ITSearchReducer = {
	searchModalIsOpen: false,
	searchResults: null,
	searchError: false,
	searchLoading: false,
};

const searchReducer = produce((draft, action) => {
	switch (action.type) {
		case SEARH_PENDING: {
			draft.searchLoading = true;
			draft.searchError = false;
			draft.searchResults = null;
			break;
		}
		case SEARCH_FULFILLED: {
			draft.searchLoading = false;
			draft.searchResults = action.payload.searchResults;
			draft.searchError = false;
			break;
		}
		case SEARCH_FAILED: {
			draft.searchLoading = false;
			draft.searchError = true;
			draft.searchResults = null;
			break;
		}
		case SET_SEARCHMODAL_STATE_FULFILLED: {
			draft.searchModalIsOpen = action.payload.searchModalIsOpen;
			break;
		}
		default: {
			break;
		}
	}
}, initialValues);

export default searchReducer;
